module.exports = __webpack_public_path__ + "img/order-video.824ece89.svg";